import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { PortfolioPlanByIdResponse, stringifyQueryParams, } from "./getPortfolioPlanById";
export const portfolioPlanByIdPublicURL = (portfolioPlanId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/portfolio-plans/${portfolioPlanId}/public`
    : `https://middleware.uat.farther.com/investment/portfolio-plans/${portfolioPlanId}/public`;
// this req/endpoint is "public" because we don't do an Oso authorization check on the person fetching the portfolio
// the only security is the token that is passed in the header
// this endpoint request is the exact same as getPortfolioPlanById
export const getPortfolioPlanByIdPublic = async (portfolioPlanId, params, config) => {
    const qs = stringifyQueryParams(params);
    const { data } = await axios.get(`${portfolioPlanByIdPublicURL(portfolioPlanId)}?${qs}`, {
        headers: {
            version: "20250403",
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
            accept: "application/json",
        },
    });
    const decoded = PortfolioPlanByIdResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[getPortfolioPlanByIdPublic.ts] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getPortfolioPlanByIdPublic.js.map